import React, { useState, useEffect } from "react";
import { Modal, Checkbox, message } from "antd";
import { patchUpdateUser } from "apis/user";
import { withAppContext } from "contexts/AppContext/AppContext";

const TNCModal = (props) => {
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [tncChecked, setTnCheck] = useState(false);
  const [userInfo, setUserInfo] = useState({
    username: "",
    _id: "",
    agreeTNC: false,
    agreeTNCDate: Date(),
  });

  useEffect(() => {
    if (props.isLoggedIn) {
      getUserInfo();
    }
  }, [props]);

  const getUserInfo = async () => {
    setLoading(true);
    const res = props.getLoggedInUser();
    setUserInfo(res);
    if (
      !res.isLoggedInUserProfileLoading &&
      (!res.agreeTNC || res.agreeTNC === false)
    ) {
      setVisible(true);
    }
    setLoading(false);
  };

  const handleReject = () => {
    props.onLogout();
    window.location.reload();
  };

  const handleAccept = async () => {
    if (!tncChecked) {
      return message.error("Please agree to acknowledgement of privacy policy");
    }

    setLoading(true);
    await patchUpdateUser(userInfo._id, {
      agreeTNC: true,
      agreeTNCDate: Date(),
    });
    message.success("Thank you for accepting the term & condition");
    setLoading(false);
    setVisible(false);
    await props.refetchLoggedInUserProfile();
  };

  return (
    <Modal
      visible={visible}
      title="Finport Term & Condition Agreement"
      okText="Accept"
      cancelText="Reject"
      cancelButtonProps={{ danger: true, disabled: loading }}
      onCancel={handleReject}
      onOk={handleAccept}
      okButtonProps={{ loading: loading }}
      closable={false}
    >
      <iframe
        src="https://finport.com.my/ftsb-terms-of-use/"
        style={{ width: "100%", height: 380 }}
      />
      <Checkbox
        value={tncChecked}
        style={{ marginTop: 16, fontWeight: 600 }}
        onChange={(e) => setTnCheck(e.target.checked)}
      >
        I acknowledge and accept the term & condition by Finport Tech Sdn Bhd
      </Checkbox>
    </Modal>
  );
};

export default withAppContext(TNCModal);
